import React, { useEffect, useState } from "react";

export default function SharedTodoList() {
  const [todos, setTodos] = useState([]);
  const [newText, setNewText] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 8;
  const apiUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const token = localStorage.getItem("token");

  async function loadTodos() {
    const res = await fetch(`${apiUrl}/todos`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    const list = Array.isArray(data) ? data : [];
    setTodos(list);
    // Clamp page to available range after loading
    const totalPages = Math.max(1, Math.ceil(list.length / pageSize));
    setPage((prev) => Math.min(prev, totalPages));
  }

  async function addTodo() {
    if (!newText.trim()) return;
    await fetch(`${apiUrl}/todos`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ text: newText }),
    });
    setNewText("");
    // Show newest first on the first page
    setPage(1);
    loadTodos();
  }

  async function toggleComplete(todoId, completed) {
    await fetch(`${apiUrl}/todos/${todoId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ completed: !completed }),
    });
    loadTodos();
  }

  async function deleteTodo(todoId) {
    await fetch(`${apiUrl}/todos/${todoId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    loadTodos();
  }

  useEffect(() => {
    loadTodos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Derive pagination values
  const totalPages = Math.max(1, Math.ceil(todos.length / pageSize));
  const start = (page - 1) * pageSize;
  const end = start + pageSize;
  const pageTodos = todos.slice(start, end);

  return (
    <div className="notepad">
      <h2>Shared Counselor To-Do List</h2>
      <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
        <input
          style={{ flex: 1, padding: 8 }}
          placeholder="Add a new note..."
          value={newText}
          onChange={(e) => setNewText(e.target.value)}
        />
        <button
          className="pager-btn"
          onClick={addTodo}
          disabled={!newText.trim()}
          aria-label="Add task"
        >
          <span aria-hidden>＋</span>
          Add
        </button>
      </div>

      <ul className="notepad-list">
        {pageTodos.map((t) => (
          <li
            key={t.todoId}
            style={{
              background: "transparent",
              padding: "10px 4px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label
              className="fun-checkbox"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                flex: 1,
              }}
            >
              <input
                type="checkbox"
                checked={!!t.completed}
                onChange={() => toggleComplete(t.todoId, t.completed)}
              />
              <span
                className="todo-text"
                style={{
                  textDecoration: t.completed ? "line-through" : "none",
                }}
              >
                {t.text}
              </span>
            </label>
            <button
              className="btn-delete-x"
              onClick={() => deleteTodo(t.todoId)}
              title="Delete task"
              aria-label={`Delete ${t.text}`}
            >
              ×
            </button>
          </li>
        ))}
      </ul>

      {/* Pagination controls */}
      <div className="pager">
        <button
          className="pager-btn"
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          disabled={page <= 1}
          aria-label="Previous page"
        >
          <span aria-hidden>←</span>
          Previous
        </button>
        <div className="pager-info">
          Page {totalPages === 0 ? 0 : page} of {totalPages}
        </div>
        <button
          className="pager-btn"
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          disabled={page >= totalPages}
          aria-label="Next page"
        >
          Next
          <span aria-hidden>→</span>
        </button>
      </div>
    </div>
  );
}
